/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
import { Container, MapTo } from '@adobe/aem-react-editable-components';
import '../../libs/aemComponents/Container';
import '../../libs/aemComponents/ExperienceFragment';
import { respGridUtil } from '@marriott/mi-headless-utils';
import { StaticWrapper } from '@marriott/mi-common-static-components';
import {
  EditableHTLWrapper,
  CardHorizontalMini,
  CobrandCardHorizontalFlexible,
  CardHorizontalFeature,
  BannerLayered,
  AccordionContainer,
  AccordionContainerEnhanced,
  CardLayered,
  CardVertical,
  RichText,
  IconBlock,
  VariableColumnContainer,
  NavigationContainerWrapper,
  NavigationUtilityLinkWrapper,
  NavigationWrapper,
  LinkList,
  Footer,
  DynamicWrapper,
  SecondaryNavigation,
} from '@marriott/mi-common-static-components';
import { OCardLayeredStandard } from '@marriott/mi-designsystem-components';
import {
  MerchandisingHeroBanner,
  MerchandisingSmallBanner,
  MerchandisingTileSkinny,
  MerchandisingBrandBanner,
  MerchandisingCardTile,
  MerchandisingModalComp,
  MerchandisingCarouselContainer,
  MerchandisingSignInModalComp,
  MerchandisingDCAContainer,
  MerchandisingPartnerCard,
  DCADecisionContainer,
  RiottMediaCard,
  MerchandisingHeroCarouselCard,
  MerchandisingEyebrowBanner,
} from '@marriott/mi-merch-components';
import {
  CardFeatures,
  CobrandContainer,
  PointsEarned,
  AwardsGallery,
  CardDetails,
  CobrandTabContainer,
  InternationalPopup,
  PointsDetails,
  StickyCta,
  CobrandCarousel,
  CardOverview,
  CobrandComparisonTray,
  AlertBanner,
  CardComparison,
  CardComparisonHeader,
  DataCell,
  CobrandWrapper,
  CtaComponent,
  CobrandWebSmallBanner,
  InterstitialComponent,
  OCountdownEyebrowBanner,
  MemberNameGreeting,
  CobrandOBannerFeature,
  DataTiles,
} from '@marriott/mi-cobrand-components';
import { HeroBanner } from '@marriott/mi-homepage-components';
import { FlyoutDrawer } from '@marriott/mi-book-components';
import { AccountContainerEditable, SignInEditable, SignInContentBlockEditable } from '@marriott/mi-account-components';
import { getAllowedComponentsForNonAuthorMode as getAllowedComponentsForNonAuthorModeUtil } from '@marriott/shared/mi-helper-utils';
const NEXT_PUBLIC_AEM_SITE = process.env.NEXT_PUBLIC_AEM_SITE;

export const AEM_REACT_MAPPING = {
  [`mi-aem-common-spa/components/common/staticwrapper`]: StaticWrapper,
  [`mi-aem-common-spa/components/content/cardhorizontalmini`]: CardHorizontalMini,
  [`mi-aem-common-spa/components/content/cobrandcardhorizontalflexible`]: CobrandCardHorizontalFlexible,
  [`mi-aem-common-spa/components/content/cardhorizontalfeature`]: CardHorizontalFeature,
  [`mi-aem-common-spa/components/content/bannerlayered`]: BannerLayered,
  [`mi-aem-common-spa/components/content/accordioncontainer`]: AccordionContainer,
  [`mi-aem-common-spa/components/content/accordioncontainerenhanced`]: AccordionContainerEnhanced,
  [`mi-aem-common-spa/components/content/iconblock`]: IconBlock,
  [`mi-aem-common-spa/components/content/merchandisingherobanner`]: MerchandisingHeroBanner,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/awards-gallery`]: AwardsGallery,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/cardoverview`]: CardOverview,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/cobrandcomparisontray`]: CobrandComparisonTray,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/cobrandcontainer`]: CobrandContainer,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/card-features`]: CardFeatures,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/pointsdetails`]: PointsDetails,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/points-section`]: PointsEarned,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/carddetails`]: CardDetails,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/stickycta`]: StickyCta,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/alertbanner`]: AlertBanner,
  [`mi-aem-common-spa/components/content/cardcarouselcontainer`]: CobrandCarousel,
  [`mi-aem-common-spa/components/content/cardlayered`]: CardLayered,
  [`mi-aem-common-spa/components/content/cardvertical`]: CardVertical,
  [`mi-aem-common-spa/components/content/richtext`]: RichText,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/popup`]: InternationalPopup,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/cobrandtabcontainer`]: CobrandTabContainer,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/card-comparison`]: CardComparison,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/cardcomparisonheader`]: CardComparisonHeader,
  [`mi-aem-common-spa/components/content/linklist`]: LinkList,
  [`mi-aem-common-spa/components/content/variablecolumncontainer`]: VariableColumnContainer,
  [`mi-aem-cobrand/components/content/card-category`]: DataCell,
  [`mi-aem-cobrand/components/content/card-data`]: DataCell,
  [`mi-aem-common-spa/components/experiencefragment`]: Container,
  [`mi-aem-common-spa/components/content/merchandisingsmallbanner`]: MerchandisingSmallBanner,
  [`mi-aem-homepage-spa/components/content/herobanner`]: HeroBanner,
  [`mi-aem-homepage-spa/components/content/universal-footer`]: Footer,
  [`mi-aem-homepage-spa/components/content/global-navigation`]: NavigationContainerWrapper,
  [`mi-aem-homepage-spa/components/content/utilityNavigation`]: NavigationUtilityLinkWrapper,
  [`mi-aem-homepage-spa/components/content/primaryNavigation`]: NavigationWrapper,
  [`mi-aem-common-spa/components/content/tileskinny`]: MerchandisingTileSkinny,
  [`mi-aem-common-spa/components/content/tilesquare`]: MerchandisingCardTile,
  [`mi-aem-common-spa/components/content/brandbanner`]: MerchandisingBrandBanner,
  [`mi-aem-common-spa/components/content/modal`]: MerchandisingModalComp,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/cobrandwrapper`]: CobrandWrapper,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/interstitial-component`]: InterstitialComponent,
  [`mi-aem-common-spa/components/content/dcaabtestwrapper`]: MerchandisingDCAContainer,
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/cta-component`]: CtaComponent,
  [`mi-aem-common-spa/components/content/tilecarouselcontainer`]: MerchandisingCarouselContainer,
  [`mi-aem-common-spa/components/content/signinmodal`]: MerchandisingSignInModalComp,
  [`mi-aem-cobrand/components/content/cobrandwebsmallbanner`]: CobrandWebSmallBanner,
  [`mi-aem-common-spa/components/content/partnercard`]: MerchandisingPartnerCard,
  [`mi-aem-common-spa/components/content/dcadecisioncontainer`]: DCADecisionContainer,
  ['mi-aem-common-spa/components/content/mangopilot']: RiottMediaCard,
  ['mi-aem-common-spa/components/content/riottmediacard']: RiottMediaCard,
  ['mi-aem-common-spa/components/content/webheromerchandisingcarousel']: MerchandisingHeroCarouselCard,
  ['mi-aem-utils/components/content/cobrand/o-countdown-eyebrow-banner']: OCountdownEyebrowBanner,
  ['mi-aem-utils/components/content/o-banner-feature']: CobrandOBannerFeature,
  ['mi-aem-utils/components/content/o-card-layered-standard']: OCardLayeredStandard,
  ['mi-aem-cobrand/components/content/member-name-greeting']: MemberNameGreeting,
  ['mi-aem-cobrand/components/content/datatile']: DataTiles,
  [`mcom-book-spa/components/flyoutcontainer`]: FlyoutDrawer,
  [`mi-aem-account/components/content/accountcontainer`]: AccountContainerEditable,
  [`mi-aem-account/components/content/signin`]: SignInEditable,
  [`mi-aem-account/components/content/signincontentblock`]: SignInContentBlockEditable,
  [`mi-aem-account/components/content/datapagecomponent`]: Container,
  [`mi-aem-common-spa/components/content/eyebrowbanner`]: MerchandisingEyebrowBanner,
  [`mi-aem-common-spa/components/content/globalnav/global-navigation`]: NavigationContainerWrapper,
  [`mi-aem-common-spa/components/content/globalnav/utilityNavigation`]: NavigationUtilityLinkWrapper,
  [`mi-aem-common-spa/components/content/globalnav/primaryNavigation`]: NavigationWrapper,
  [`mi-aem-common-spa/components/common/dynamicwrapper`]: DynamicWrapper,
  [`mi-aem-common-spa/components/content/secondary-navigation`]: SecondaryNavigation,
};

export const AEM_REACT_TITLE_MAPPING = {
  'mi-aem-common-spa/components/common/staticwrapper': 'Static Wrapper',
  'mi-aem-common-spa/components/content/cardhorizontalmini': 'Card Horizontal Mini-Standard',
  'mi-aem-common-spa/components/content/cobrandcardhorizontalflexible': 'Cobrand-Card Horizontal Flexible',
  'mi-aem-common-spa/components/content/cardhorizontalfeature': 'Card Horizontal Feature',
  'mi-aem-common-spa/components/content/bannerlayered': 'Banner Layered',
  'mi-aem-common-spa/components/content/accordioncontainer': 'Accordion Container',
  'mi-aem-common-spa/components/content/accordioncontainerenhanced': 'Accordion Container-Enhanced',
  'mi-aem-common-spa/components/content/iconblock': 'Icon Block',
  'mi-aem-common-spa/components/content/merchandisingherobanner': 'Merchandising Hero Banner',
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/awards-gallery`]: 'Awards Gallery',
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/cardoverview`]: 'Card Overview',
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/cobrandcomparisontray`]: 'Comparison Tray',
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/cobrandcontainer`]: 'Cobrand Container',
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/card-features`]: 'Card Features',
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/pointsdetails`]: 'Points Details',
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/points-section`]: 'Points Section',
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/carddetails`]: 'Card Details',
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/stickycta`]: 'Sticky CTA',
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/alertbanner`]: 'Alert Banner',
  'mi-aem-common-spa/components/content/cardcarouselcontainer': 'Card Carousel Container',
  'mi-aem-common-spa/components/content/cardlayered': 'Card Layered',
  'mi-aem-common-spa/components/content/cardvertical': 'Card Vertical',
  'mi-aem-common-spa/components/content/richtext': 'Rich Text',
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/popup`]: 'Popup',
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/cobrandtabcontainer`]: 'Cobrand Tab Container',
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/card-comparison`]: 'Card Comparison',
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/cardcomparisonheader`]: 'Card Comparison Header',
  'mi-aem-common-spa/components/content/linklist': 'Link List',
  'mi-aem-common-spa/components/content/variablecolumncontainer': 'Variable Column Container',
  'mi-aem-cobrand/components/content/card-category': 'Card Category',
  'mi-aem-cobrand/components/content/card-data': 'Card Data',
  'mi-aem-common-spa/components/experiencefragment': 'Experience Fragment',
  'mi-aem-common-spa/components/content/merchandisingsmallbanner': 'Merchandising Small Banner',
  'mi-aem-homepage-spa/components/content/herobanner': 'Homepage Hero Banner',
  'mi-aem-homepage-spa/components/content/universal-footer': 'Universal Footer',
  'mi-aem-homepage-spa/components/content/global-navigation': 'Global Navigation',
  'mi-aem-homepage-spa/components/content/utilityNavigation': 'Utility Navigation',
  'mi-aem-homepage-spa/components/content/primaryNavigation': 'Primary Navigation',
  'mi-aem-common-spa/components/content/tileskinny': 'Tile Skinny',
  'mi-aem-common-spa/components/content/tilesquare': 'Tile Square',
  'mi-aem-common-spa/components/content/brandbanner': 'Brand Banner',
  'mi-aem-common-spa/components/content/modal': 'Modal',
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/cobrandwrapper`]: 'Cobrand Wrapper',
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/interstitial-component`]: 'Interstitial Component',
  'mi-aem-common-spa/components/content/dcaabtestwrapper': 'DCA A/B Test Wrapper',
  [`${NEXT_PUBLIC_AEM_SITE}/components/content/cta-component`]: 'CTA Component',
  'mi-aem-common-spa/components/content/tilecarouselcontainer': 'Tile Carousel Container',
  'mi-aem-common-spa/components/content/signinmodal': 'Signin Modal',
  'mi-aem-cobrand/components/content/cobrandwebsmallbanner': 'Cobrand Web Small Banner',
  'mi-aem-common-spa/components/content/partnercard': 'Partner Card',
  'mi-aem-common-spa/components/content/dcadecisioncontainer': 'DCA Decision Container',
  'mi-aem-common-spa/components/content/mangopilot': 'Mango Pilot',
  'mi-aem-common-spa/components/content/riottmediacard': 'Riott Media Card',
  'mi-aem-common-spa/components/content/webheromerchandisingcarousel': 'Web Hero Merchandising Carousel',
  'mi-aem-utils/components/content/cobrand/o-countdown-eyebrow-banner': 'Countdown Eyebrow Banner',
  'mi-aem-utils/components/content/o-banner-feature': 'Banner Feature',
  'mi-aem-utils/components/content/o-card-layered-standard': 'Card Layered Standard',
  'mi-aem-cobrand/components/content/member-name-greeting': 'Member Name Greeting',
  'mi-aem-cobrand/components/content/datatile': 'Data Tiles',
  'mcom-book-spa/components/flyoutcontainer': 'Flyout Container',
  'mi-aem-account/components/content/accountcontainer': 'Account Container',
  'mi-aem-account/components/content/signin': 'Sign In',
  'mi-aem-account/components/content/signincontentblock': 'Sign In Content Block',
  'mi-aem-account/components/content/datapagecomponent': 'Data Page Component',
  'mi-aem-common-spa/components/content/eyebrowbanner': 'Eyebrow Banner',
  'mi-aem-common-spa/components/content/globalnav/global-navigation': 'Global Navigation',
  'mi-aem-common-spa/components/content/globalnav/utilityNavigation': 'Utility Navigation',
  'mi-aem-common-spa/components/content/globalnav/primaryNavigation': 'Primary Navigation',
  'mi-aem-common-spa/components/common/dynamicwrapper': 'Dynamic Phoenix Wrapper',
  'mi-aem-common-spa/components/content/secondary-navigation': 'Secondary Navigation',
};

export const getAllowedComponentsForNonAuthorMode = model => {
  return getAllowedComponentsForNonAuthorModeUtil(model, AEM_REACT_MAPPING, AEM_REACT_TITLE_MAPPING);
};

export const defineComponentMapping = (
  allowedComponents,
  pagePath,
  isAuthorMode,
  dataLayer,
  columnContainerParams,
  showError,
  resolvedUrl,
  featureTextParams,
  pageFlags,
  isRtl,
  featureFlags = {},
  { cobrandCards, ecmCardPriority, ecmUserCards, ecmCardMapping, ecmSelectedCardParam } = {}
) => {
  const logger = global.loggerInstance?.('defineComponentMapping');
  const loggerObj = logger?.log;
  const log = typeof loggerObj?.debug === 'function' ? (...args) => loggerObj.debug(...args) : () => {};
  const logError = typeof loggerObj?.error === 'function' ? (...args) => loggerObj.error(...args) : () => {};

  try {
    MapTo(`mi-aem-common-spa/components/content/merchandisingsmallbanner`)(
      props => <MerchandisingSmallBanner {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'MerchandesingSmallBanner',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-common-spa/components/common/staticwrapper`)(StaticWrapper, {
      emptyLabel: 'StaticWrapper',
      isEmpty: false,
    });
    MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/cobrandtabcontainer`)(
      props => (
        <CobrandTabContainer
          {...props}
          isAuthorMode={isAuthorMode}
          {...columnContainerParams}
          allowedComponents={allowedComponents}
        />
      ),
      {
        emptyLabel: 'CobrandTabContainer',
        isEmpty: false,
      }
    );
    MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/card-comparison`)(
      props => (
        <CardComparison
          {...props}
          isAuthorMode={isAuthorMode}
          cobrandCards={cobrandCards}
          isGlobalNavSticky={columnContainerParams?.isGlobalNavSticky}
        />
      ),
      {
        emptyLabel: 'CardComparison',
        isEmpty: false,
      }
    );
    MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/cardcomparisonheader`)(
      props => <CardComparisonHeader {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'Card Comparison Header',
        isEmpty: false,
      }
    );
    MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/cobrandcomparisontray`)(
      props => <CobrandComparisonTray {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'CobrandComparisonTray',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-homepage-spa/components/content/herobanner`)(props => (
      <HeroBanner {...props} isAuthorMode={isAuthorMode} />
    ));
    MapTo(`mi-aem-cobrand/components/content/card-category`)(
      props => <DataCell {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'datacell',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-cobrand/components/content/card-data`)(props => <DataCell {...props} isAuthorMode={isAuthorMode} />, {
      emptyLabel: 'datacell',
      isEmpty: false,
    });
    MapTo(`mi-aem-common-spa/components/content/cardhorizontalmini`)(
      props => (
        <>
          <CardHorizontalMini {...props} />
        </>
      ),
      {
        emptyLabel: 'CardHorizontalMini',
        isEmpty: false,
      }
    );
    MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/cardoverview`)(CardOverview, {
      emptyLabel: 'CardOverview',
      isEmpty: false,
    });
    MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/interstitial-component`)(InterstitialComponent, {
      emptyLabel: 'InterstitialComponent',
      isEmpty: false,
    });
    MapTo(`mi-aem-common-spa/components/content/iconblock`)(IconBlock, {
      emptyLabel: 'IconBlock',
      isEmpty: false,
    });
    MapTo(`mi-aem-common-spa/components/content/merchandisingherobanner`)(
      props => (
        <>
          <MerchandisingHeroBanner {...props} />
        </>
      ),
      {
        emptyLabel: 'MerchandisingHeroBanner',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-common-spa/components/content/tileskinny`)(MerchandisingTileSkinny, {
      emptyLabel: 'Tile Skinny',
      isEmpty: false,
    });
    MapTo(`mi-aem-common-spa/components/content/tilesquare`)(MerchandisingCardTile, {
      emptyLabel: 'Tile Square',
      isEmpty: false,
    });
    MapTo(`mi-aem-common-spa/components/content/brandbanner`)(MerchandisingBrandBanner, {
      emptyLabel: 'Brand Banner',
      isEmpty: false,
    });
    MapTo(`mi-aem-common-spa/components/content/eyebrowbanner`)(MerchandisingEyebrowBanner, {
      emptyLabel: 'Eyebrow Banner',
      isEmpty: false,
    });
    MapTo(`mi-aem-common-spa/components/content/modal`)(MerchandisingModalComp, {
      emptyLabel: 'Portal Modal',
      isEmpty: false,
    });
    MapTo(`mi-aem-common-spa/components/content/signinmodal`)(MerchandisingSignInModalComp, {
      emptyLabel: 'Sign-in Modal',
      isEmpty: false,
    });
    MapTo(`mi-aem-common-spa/components/content/partnercard`)(MerchandisingPartnerCard, {
      emptyLabel: 'Partner Card',
      isEmpty: false,
    });
    MapTo('mi-aem-common-spa/components/content/tilecarouselcontainer')(
      props => <MerchandisingCarouselContainer {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'Tile Carousel Container',
        isEmpty: false,
      }
    );
    MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/awards-gallery`)(AwardsGallery, {
      emptyLabel: 'AwardsGallery',
      isEmpty: false,
    });
    MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/points-section`)(PointsEarned, {
      emptyLabel: 'PointsEarned',
      isEmpty: false,
    });
    MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/carddetails`)(
      props => <CardDetails {...props} {...columnContainerParams} />,
      {
        emptyLabel: 'CardDetails',
        isEmpty: false,
      }
    );
    MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/stickycta`)(StickyCta, {
      emptyLabel: 'StickyCta',
      isEmpty: false,
    });
    MapTo(`mi-aem-common-spa/components/content/linklist`)(LinkList);
    MapTo(`mi-aem-common-spa/components/content/cardlayered`)(CardLayered, {
      emptyLabel: 'CardLayered',
      isEmpty: false,
    });
    MapTo(`mi-aem-common-spa/components/content/cardvertical`)(CardVertical, {
      emptyLabel: 'CardVertical',
      isEmpty: false,
    });
    MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/card-features`)(
      props => <CardFeatures {...props} {...featureTextParams} />,
      {
        emptyLabel: 'CardFeatures',
        isEmpty: false,
      }
    );
    MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/pointsdetails`)(PointsDetails, {
      emptyLabel: 'PointsDetails',
      isEmpty: false,
    });
    MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/cobrandcontainer`)(
      props => (
        <CobrandContainer
          {...props}
          isAuthorMode={isAuthorMode}
          resolvedUrl={resolvedUrl}
          {...pageFlags}
          {...columnContainerParams}
          allowedComponents={allowedComponents}
        />
      ),
      {
        emptyLabel: 'CobrandContainer',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-common-spa/components/content/cardcarouselcontainer`)(
      props => (
        <CobrandCarousel
          {...props}
          isAuthorMode={isAuthorMode}
          allowedComponents={allowedComponents}
          {...columnContainerParams}
          isRtl={isRtl}
          resolvedUrl={resolvedUrl}
        />
      ),
      {
        emptyLabel: 'CardCarouselContainer',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-common-spa/components/content/cobrandcardhorizontalflexible`)(CobrandCardHorizontalFlexible, {
      emptyLabel: 'CobrandCardHorizontalFlexible',
      isEmpty: false,
    });
    MapTo(`mi-aem-common-spa/components/content/cardhorizontalfeature`)(CardHorizontalFeature, {
      emptyLabel: 'CardHorizontalFeature',
      isEmpty: false,
    });
    MapTo(`mi-aem-common-spa/components/content/bannerlayered`)(BannerLayered, {
      emptyLabel: 'BannerLayered',
      isEmpty: false,
    });
    MapTo(`mi-aem-common-spa/components/content/accordioncontainer`)(
      props => <AccordionContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />,
      {
        emptyLabel: 'accordioncontainer',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-common-spa/components/content/accordioncontainerenhanced`)(props => (
      <AccordionContainerEnhanced {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
    ));
    MapTo(`mi-aem-common-spa/components/content/richtext`)(RichText, {
      emptyLabel: 'RichText',
      isEmpty: false,
    });
    MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/popup`)(
      props => <InternationalPopup {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />,
      {
        emptyLabel: 'popup',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-common-spa/components/content/variablecolumncontainer`)(
      props => (
        <VariableColumnContainer
          {...props}
          isAuthorMode={isAuthorMode}
          {...columnContainerParams}
          allowedComponents={allowedComponents}
        />
      ),
      {
        emptyLabel: 'VariableColumnContainer',
        isEmpty: false,
      }
    );
    MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/alertbanner`)(
      props => <AlertBanner {...props} isAuthorMode={isAuthorMode} showError={showError} />,
      {
        emptyLabel: 'AlertBanner',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-homepage-spa/components/content/global-navigation`)(
      props => (
        <NavigationContainerWrapper
          {...props}
          isAuthorMode={isAuthorMode}
          featureFlagLogo={featureFlags.featureFlagLogo}
          featureFlagLegacyNav={featureFlags.featureFlagLegacyNav}
        />
      ),
      {
        emptyLabel: 'NavigationContainerWrapper',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-homepage-spa/components/content/utilityNavigation`)(NavigationUtilityLinkWrapper, {
      emptyLabel: 'NavigationUtilityLinkWrapper',
      isEmpty: false,
    });
    MapTo(`mi-aem-homepage-spa/components/content/primaryNavigation`)(NavigationWrapper, {
      emptyLabel: 'NavigationWrapper',
      isEmpty: false,
    });
    MapTo('mi-aem-utils/components/content/o-card-layered-standard')(
      props => <OCardLayeredStandard {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'OCardLayeredStandard',
        isEmpty: false,
      }
    );
    MapTo('mi-aem-homepage-spa/components/content/universal-footer')(Footer, {
      emptyLabel: 'Footer',
      isEmpty: false,
    });
    MapTo(`mi-aem-common-spa/components/content/dcaabtestwrapper`)(
      props => (
        <MerchandisingDCAContainer
          {...props}
          isAuthorMode={isAuthorMode}
          {...columnContainerParams}
          allowedComponents={allowedComponents}
          resolvedUrl={resolvedUrl}
        />
      ),
      {
        emptyLabel: 'DCA AB Test Wrapper',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-common-spa/components/content/dcadecisioncontainer`)(
      props => (
        <DCADecisionContainer
          {...props}
          isAuthorMode={isAuthorMode}
          {...columnContainerParams}
          allowedComponents={allowedComponents}
          resolvedUrl={resolvedUrl}
        />
      ),
      {
        emptyLabel: 'DCA Wrapper',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-common-spa/components/content/webheromerchandisingcarousel`)(
      props => <MerchandisingHeroCarouselCard {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'MerchandisingHeroCarouselCard',
        isEmpty: false,
      }
    );
    MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/cobrandwrapper`)(
      props => (
        <CobrandWrapper
          {...props}
          isAuthorMode={isAuthorMode}
          {...columnContainerParams}
          allowedComponents={allowedComponents}
          resolvedUrl={resolvedUrl}
        />
      ),
      {
        emptyLabel: 'CobrandWrapper',
        isEmpty: false,
      }
    );
    MapTo('mi-aem-common-spa/components/content/mangopilot')(props => {
      return <RiottMediaCard {...props} isAuthorMode={isAuthorMode} />;
    });
    MapTo('mi-aem-common-spa/components/content/riottmediacard')(props => {
      return <RiottMediaCard {...props} isAuthorMode={isAuthorMode} />;
    });

    MapTo('mi-aem-cobrand/components/content/member-name-greeting')(
      props => (
        <MemberNameGreeting
          {...props}
          isAuthorMode={isAuthorMode}
          cobrandCards={cobrandCards}
          userCards={ecmUserCards}
          cardMapping={ecmCardMapping}
          currentCardParam={ecmSelectedCardParam}
        />
      ),
      {
        emptyLabel: 'MemberNameGreeting',
        isEmpty: false,
      }
    );

    MapTo(`${NEXT_PUBLIC_AEM_SITE}/components/content/cta-component`)(
      props => <CtaComponent {...props} isAuthorMode={isAuthorMode} {...columnContainerParams} />,
      {
        emptyLabel: 'CtaComponent',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-cobrand/components/content/cobrandwebsmallbanner`)(
      props => <CobrandWebSmallBanner {...props} ecmCardPriority={ecmCardPriority} />,
      {
        emptyLabel: 'CobrandWebSmallBanner',
        isEmpty: false,
      }
    );
    MapTo('mi-aem-utils/components/content/cobrand/o-countdown-eyebrow-banner')(
      props => <OCountdownEyebrowBanner {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'OCountdownEyebrowBanner',
        isEmpty: false,
      }
    );
    MapTo('mi-aem-utils/components/content/o-banner-feature')(
      props => <CobrandOBannerFeature {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'CobrandOBannerFeature',
        isEmpty: false,
      }
    );

    MapTo('mi-aem-cobrand/components/content/datatile')(props => <DataTiles {...props} isAuthorMode={isAuthorMode} />, {
      emptyLabel: 'DataTiles',
      isEmpty: false,
    });

    MapTo(`mcom-book-spa/components/flyoutcontainer`)(
      props => <FlyoutDrawer {...props.model} {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'FlyoutDrawer',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-account/components/content/accountcontainer`)(
      props => <AccountContainerEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'accountcontainer',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-account/components/content/signin`)(
      props => <SignInEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'signin',
      }
    );
    MapTo(`mi-aem-account/components/content/signincontentblock`)(
      props => <SignInContentBlockEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'signincontentblock',
      }
    );
    const DataPageVariationConfig = {
      emptyLabel: 'Data Page',

      isEmpty: function (props) {
        return !props || !props.configured;
      },
    };
    MapTo('mi-aem-account/components/content/datapagecomponent')(props => {
      const gridItems = props?.model?.cqItems?.responsivegrid?.[':items'];
      const isAccountContainer = gridItems ? Object.keys(gridItems)?.[0]?.includes('accountcontainer') : false;

      return (
        <Container
          isInEditor
          {...props}
          isPage={false}
          model={isAccountContainer ? respGridUtil(props?.model?.cqItems?.responsivegrid) : props?.model}
        />
      );
    }, DataPageVariationConfig);

    // Temporary workaround due to import issues remove once the platform resolves the import problem

    const ExperienceFragmentVariationConfig = {
      emptyLabel: 'Experience Fragment',

      isEmpty: function (props) {
        return !props || !props.configured;
      },
    };
    MapTo('mi-aem-common-spa/components/experiencefragment')(props => {
      return (
        <Container
          isInEditor
          {...props}
          isPage={false}
          model={respGridUtil(props?.model?.cqItems?.root?.[':items']?.responsivegrid, { normalizeTracking: true })}
        />
      );
    }, ExperienceFragmentVariationConfig);
    MapTo(`mi-aem-common-spa/components/content/globalnav/global-navigation`)(props => (
      <NavigationContainerWrapper
        {...props}
        isAuthorMode={isAuthorMode}
        featureFlagLogo={featureFlags.featureFlagLogo}
        featureFlagLegacyNav={featureFlags.featureFlagLegacyNav}
      />
    ));
    MapTo(`mi-aem-common-spa/components/content/globalnav/utilityNavigation`)(NavigationUtilityLinkWrapper);
    MapTo(`mi-aem-common-spa/components/content/globalnav/primaryNavigation`)(NavigationWrapper);
    MapTo(`mi-aem-common-spa/components/common/dynamicwrapper`)(DynamicWrapper);
    MapTo(`mi-aem-common-spa/components/content/secondarynavigation`)(SecondaryNavigation);

    const existingMappings = Object.keys(AEM_REACT_MAPPING);

    // Validate allowedComponents before processing
    if (allowedComponents && Array.isArray(allowedComponents)) {
      let successCount = 0;
      let failureCount = 0;

      allowedComponents.forEach((mapping, index) => {
        try {
          // Validate mapping object structure
          if (!mapping || typeof mapping !== 'object') {
            throw new Error(`Invalid mapping object at index ${index}`);
          }

          if (!mapping.path || typeof mapping.path !== 'string') {
            throw new Error(`Invalid or missing path in mapping at index ${index}`);
          }

          const baseModelPath = '/jcr:content/root/responsivegrid/';
          const componentPath = mapping.path.split(baseModelPath)[1];

          if (!componentPath) {
            throw new Error(`Unable to extract component path from: ${mapping.path}`);
          }

          if (existingMappings.indexOf(componentPath) === -1) {
            MapTo(componentPath)(EditableHTLWrapper, {
              emptyLabel: mapping.title || 'Component',
              isEmpty: false,
            });
            successCount++;
          } else {
            if (process.env.NODE_ENV === 'development') {
              log('Mapping already exists, skipping:', componentPath);
            }
          }
        } catch (mappingError) {
          failureCount++;
          if (process.env.NODE_ENV === 'development') {
            logError(`Failed to map component at index ${index}:`, {
              error: mappingError.message,
              mapping: mapping,
              stack: mappingError.stack,
            });
          }
          // Continue processing remaining components
        }
      });

      if (process.env.NODE_ENV === 'development') {
        log(
          `Component mapping complete. Success: ${successCount}, Failed: ${failureCount}, Total: ${allowedComponents.length}`
        );
      }
    } else if (process.env.NODE_ENV === 'development') {
      log('No allowed components provided or invalid format');
    }
  } catch (err) {
    // Always log errors regardless of environment - use your server logger, not console
    logError('Critical error in defineComponentMapping:', {
      error: err.message,
      stack: err.stack,
    });
    // Re-throw so the caller (page bootstrap) can decide recovery strategy.
    // Silent failure here means EVERY AEM component renders as blank with zero observability.
    throw err;
  }
};
